import { InvoiceScheme, InvoiceType } from '../Types/invoicesTypes';

const mapInvoiceTypeNumber = (value: number): InvoiceType => {
  switch (value) {
    case 1:
      return InvoiceType.Prepayment;
    case 2:
      return InvoiceType.Final;
    case 3:
      return InvoiceType.Correction;
    case 4:
      return InvoiceType.Refund;
    case 5:
      return InvoiceType.Proforma;
    default:
      return InvoiceType.Standard;
  }
};

export const normalizeInvoiceScheme = (value: unknown): InvoiceScheme => {
  if (typeof value === 'number') {
    return value === 1 ? InvoiceScheme.TravelMargin : InvoiceScheme.Standard;
  }

  const raw = String(value ?? '')
    .trim()
    .toLowerCase();

  if (raw === '1' || raw === 'travelmargin' || raw === 'travel_margin' || raw === 'travel-margin') {
    return InvoiceScheme.TravelMargin;
  }

  return InvoiceScheme.Standard;
};

export const normalizeInvoiceType = (value: unknown): InvoiceType => {
  if (typeof value === 'number') {
    return mapInvoiceTypeNumber(value);
  }

  const raw = String(value ?? '')
    .trim()
    .toLowerCase();

  if (/^\d+$/.test(raw)) {
    return mapInvoiceTypeNumber(Number(raw));
  }

  switch (raw) {
    case 'prepayment':
      return InvoiceType.Prepayment;
    case 'final':
      return InvoiceType.Final;
    case 'correction':
      return InvoiceType.Correction;
    case 'refund':
      return InvoiceType.Refund;
    case 'proforma':
      return InvoiceType.Proforma;
    default:
      return InvoiceType.Standard;
  }
};
